import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAirportPopup, setShowAirportPopup } from '../appSlice';

const AnotherAirportPopup = () => {
  const showPopup = useSelector(selectAirportPopup);
  const dispatch = useDispatch();

  // if (!showPopup) {
  //   return null;
  // }

  const hidePopup = () =>  dispatch(setShowAirportPopup(false));

  return (
    <div className={`airport-popup-overlay ${!showPopup ? 'hide-popup' : null} `} onClick={hidePopup}>
      <div className="airport-popup">
        <button className="airport-popup-close" onClick={hidePopup}>
          <i className="ri-close-line"></i>
        </button>
        <iframe src="https://blocksurvey.io/airport-departure-survey-yOi9nO9mS5SyM_F3cRHBSQ-o" />
      </div>
    </div>
  );
};

export default AnotherAirportPopup;
